import { LoginSchema } from './loginSchema';

export const initialState: LoginSchema = {
  auth: {
    isAuth: false,
    isRegUsingLink: false,
    isReenteringLink: false,
    loading: false,
  },
  sms: {
    loading: false,
  },
  register: {
    agreement: false,
    privacy: false,
    smartCaptureToken: '',
    loading: false,
  },
};
